import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Switch } from '../ui/switch';
import { Loader2, ChevronDown } from 'lucide-react';
import api from '../../utils/axios';
import { EstadoRun } from './EstadoRun';
import { fmtDuracion, fmtFechaHora } from '../actividad/actividadUtils';

const Fila = ({ r, i }) => {
  const [abierta, setAbierta] = useState(false);
  const detalle = r.error || r.resumen;
  return (
    <>
      <tr onClick={() => detalle && setAbierta(!abierta)} className={`${detalle ? 'cursor-pointer' : ''} hover:bg-slate-50/80 transition-colors duration-150`} data-testid={`proc-run-${i}`}>
        <td className="px-4 py-2.5 whitespace-nowrap tabular-nums text-slate-600">{fmtFechaHora(r.inicio)}</td>
        <td className="px-4 py-2.5"><p className="font-semibold text-slate-800">{r.nombre}</p><p className="text-[11px] text-slate-400">{r.grupo}</p></td>
        <td className="px-4 py-2.5"><EstadoRun estado={r.estado} /></td>
        <td className="px-4 py-2.5 tabular-nums whitespace-nowrap text-slate-600">{r.duracion_seg != null ? fmtDuracion(r.duracion_seg) : '—'}</td>
        <td className="px-4 py-2.5 max-w-md"><p className={`truncate ${r.error ? 'text-rose-700' : 'text-slate-600'}`}>{r.error || r.resumen || '—'}</p></td>
        <td className="px-4 py-2.5 text-xs text-slate-500 whitespace-nowrap">{r.origen}</td>
        <td className="px-3 py-2.5 text-slate-300">{detalle && <ChevronDown size={15} className={`transition-transform duration-200 ${abierta ? 'rotate-180' : ''}`} />}</td>
      </tr>
      {abierta && (
        <tr className="bg-slate-50/80" data-testid={`proc-run-detalle-${i}`}>
          <td colSpan={7} className="px-4 py-3 text-xs">
            {r.resumen && <p className="text-slate-700"><span className="font-semibold">Resultado:</span> {r.resumen}</p>}
            {r.error && <p className="mt-1 text-rose-700 whitespace-pre-wrap break-words"><span className="font-semibold">Error:</span> {r.error}</p>}
          </td>
        </tr>
      )}
    </>
  );
};

export const CorridasTabla = ({ horas, proceso, procesoNombre, onLimpiar, refresco }) => {
  const [soloErrores, setSoloErrores] = useState(false);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    const params = { horas, limit: 500 };
    if (proceso) params.proceso = proceso;
    if (soloErrores) params.estado = 'error';
    try { setData((await api.get('/procesos-automaticos/corridas', { params })).data); } catch { setData({ items: [], total: 0 }); }
  }, [horas, proceso, soloErrores]);

  useEffect(() => { load(); }, [load, refresco]);

  return (
    <Card className="bg-white border-slate-200 overflow-hidden" data-testid="proc-corridas">
      <div className="p-4 flex flex-wrap items-center gap-3 border-b border-slate-100">
        <h3 className="text-base font-bold text-slate-800" style={{ fontFamily: 'Manrope, sans-serif' }}>Historial de corridas</h3>
        {proceso && (
          <button onClick={onLimpiar} className="rounded-full bg-teal-700 px-3 py-1 text-xs font-semibold text-white" data-testid="proc-filtro-limpiar">
            {procesoNombre} ✕
          </button>
        )}
        <label className="ml-auto flex items-center gap-2 text-sm text-slate-600">
          <Switch checked={soloErrores} onCheckedChange={setSoloErrores} data-testid="proc-solo-errores" /> Solo errores
        </label>
        {data && <span className="text-xs text-slate-400" data-testid="proc-corridas-total">{data.total} corridas</span>}
      </div>
      <div className="overflow-x-auto max-h-[36rem] overflow-y-auto">
        {!data ? <div className="py-12 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-teal-700" /></div> : (
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
              <tr>{['Fecha', 'Proceso', 'Estado', 'Duración', 'Resultado', 'Origen', ''].map((h) => <th key={h} className="px-4 py-2.5 text-left font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {data.items.map((r, i) => <Fila key={`${r.proceso}-${r.inicio}-${i}`} r={r} i={i} />)}
              {!data.items.length && <tr><td colSpan={7} className="py-10 text-center text-slate-400" data-testid="proc-corridas-vacio">No hay corridas para este filtro.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </Card>
  );
};

export default CorridasTabla;
